import React from "react";
import "./comingsoon.css";

import EventCard from "../eventcard/EventCard";

import noimage from "../../assets/photos-coming-soon.jpg";
function ComingSoon() {
  const newslists = [
    {
      id: 1,
      image: noimage,
      name: "Coming Soon",
      data: "-",
      context:
        "-",
      detail:
        "-",
    },
    {
      id: 2,
      image: noimage,
      name: "Coming Soon",
      data: "-",
      context:
        "-",
      detail:
        "-",
    },
  ];

  return (
    <section className="newproduct-section">
      <div className="container">
        <h2 className="sub-heading">เร็วๆนี้</h2>
        <div className="events-grid card-box">
          {newslists.slice(0, 3).map((item) => (
            <EventCard
              key={item.id}
              id={item.id}
              image={item.image}
              name={item.name}
              date={item.data}
              context={item.context}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ComingSoon;
